import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=37635bf6&"
import script from "./TabBar.vue?vue&type=script&lang=js&"
export * from "./TabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports